module.exports = __webpack_public_path__ + "img/cons_7.4a6c0877.jpg";